import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Pencil, Trash2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { clienteName, eur, fmtDate, STATI_RECLAMO } from "../lib/format";
import { PageHeader } from "../components/Layout";
import { Targa } from "../components/Targa";
import { ReclamoBadge } from "../components/Badges";
import { ReclamoDialog } from "../components/ReclamoDialog";
import { Button } from "../components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

export default function Reclami() {
  const [items, setItems] = useState([]);
  const [stato, setStato] = useState("");
  const [edit, setEdit] = useState(null);

  const load = () => api.get("/reclami", { params: { stato } }).then((r) => setItems(r.data));
  useEffect(() => { load(); }, [stato]); // eslint-disable-line

  const remove = async (r) => {
    if (!window.confirm(`Eliminare il reclamo ${r.numero}?`)) return;
    try { await api.delete(`/reclami/${r.id}`); toast.success("Reclamo eliminato"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div>
      <PageHeader title="Reclami & interventi" subtitle="Guasti segnalati e riparazioni in garanzia. Per aprire un reclamo, entra nella scheda della garanzia." />
      <Tabs value={stato || "all"} onValueChange={(v) => setStato(v === "all" ? "" : v)} className="mb-4">
        <TabsList className="flex-wrap">
          <TabsTrigger value="all" data-testid="filter-reclami-all">Tutti</TabsTrigger>
          {Object.entries(STATI_RECLAMO).map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`filter-reclami-${v}`}>{l}</TabsTrigger>)}
        </TabsList>
      </Tabs>
      <div className="overflow-x-auto rounded-md border bg-white">
        <Table>
          <TableHeader><TableRow>
            <TableHead>N°</TableHead><TableHead>Targa</TableHead><TableHead>Garanzia / Cliente</TableHead><TableHead>Componente</TableHead><TableHead>Apertura</TableHead><TableHead>Costo</TableHead><TableHead>Stato</TableHead><TableHead className="w-24" />
          </TableRow></TableHeader>
          <TableBody>
            {items.length === 0 && <TableRow><TableCell colSpan={8} className="py-10 text-center text-muted-foreground">Nessun reclamo</TableCell></TableRow>}
            {items.map((r) => (
              <TableRow key={r.id} data-testid={`reclami-row-${r.id}`}>
                <TableCell className="font-mono text-xs font-bold">{r.numero}</TableCell>
                <TableCell><Targa value={r.garanzia?.veicolo?.targa} /></TableCell>
                <TableCell>
                  <Link to={`/garanzie/${r.garanzia_id}`} className="font-mono text-xs text-[#B08D57] hover:underline">{r.garanzia?.numero}</Link>
                  <div className="text-sm font-semibold">{clienteName(r.garanzia?.cliente)}</div>
                </TableCell>
                <TableCell><div className="text-sm font-semibold">{r.componente}</div><div className="max-w-xs truncate text-xs text-muted-foreground">{r.descrizione}</div></TableCell>
                <TableCell className="text-sm">{fmtDate(r.data_apertura)}</TableCell>
                <TableCell className="text-sm font-semibold">{eur(r.costo_ricambi + r.costo_manodopera)}</TableCell>
                <TableCell><ReclamoBadge stato={r.stato} /></TableCell>
                <TableCell className="whitespace-nowrap text-right">
                  <Button size="icon" variant="ghost" onClick={() => setEdit(r)} data-testid={`edit-reclamo-${r.id}`}><Pencil className="h-4 w-4" /></Button>
                  <Button size="icon" variant="ghost" onClick={() => remove(r)} data-testid={`delete-reclamo-${r.id}`}><Trash2 className="h-4 w-4 text-red-600" /></Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <ReclamoDialog open={!!edit} onClose={() => setEdit(null)} initial={edit} garanziaId={edit?.garanzia_id} onSaved={load} />
    </div>
  );
}
